import { useMemo } from 'react';

import { FilterWithPopover } from '@occc/ui-design-system';
import { pluralize } from '@occc-app/lib/strings';
import { LocationFragment } from '@occc/graphql';

import { LocationsFilterForm } from './LocationsFilterForm';

type LocationsFilterProps = {
  disabled?: boolean;
  locations: LocationFragment[];
  onLocationsChange: (locations: LocationFragment[]) => void;
};

export const LocationsFilter = ({
  locations,
  onLocationsChange,
  disabled,
}: LocationsFilterProps) => {
  const filterButtonLabel = useMemo(() => {
    return locations.length > 0
      ? `${locations.length} ${pluralize(locations.length, 'Location')}`
      : 'All Locations';
  }, [locations.length]);

  return (
    <FilterWithPopover
      disabled={disabled}
      renderFilterForm={({ onFilterClose }) => {
        return (
          <LocationsFilterForm
            locations={locations}
            onFilterFormReset={() => {
              onLocationsChange([]);
              onFilterClose();
            }}
            onFilterFormSubmit={(values) => {
              onLocationsChange(values.locations);
              onFilterClose();
            }}
          />
        );
      }}
      filterButtonLabel={filterButtonLabel}
    />
  );
};
